module.exports = __webpack_public_path__ + "static/img/icon_man.766bbf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/icon_man.png
// module id = FDO6
// module chunks = 96